import React, { useEffect } from 'react';
import { Container } from './styled';
import { useParams } from 'react-router-dom';
import MatchOddsStore from './store';
import InternationalOdds from './IntegrationOdds';

const MatchOdds = ({ gameData }) => {
  let { id } = useParams();
  const { getAll, data, loading } = MatchOddsStore();

  useEffect(() => {
    getAll(id);
  }, []);
  return (
    <Container>
      <InternationalOdds data={data} gameData={gameData} />
    </Container>
  );
};

export default MatchOdds;
